import React, { Component } from 'react';
import { translate } from 'react-i18next';
import brandLogo from '../../images/brand-logo-inverse-light.png';

class PasswordChange extends Component {
  render() {
    const { t } = this.props;
    return (
      <div>
        <button
          className="hidden"
          data-target="#PassworChange"
          data-toggle="modal"
          id="btnPassworChange"
          type="button">
        </button>
        <div className="modal fade" id="PassworChange" role="dialog" style={{ textAlign: "left" }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="navbar-brand">
                  <img alt="IOS OFFICES" className="brand-logo" src={brandLogo} />
                </div>
              </div>
              <div className="modal-body">
                <form className="form-horizontal" method="post">
                  <fieldset>
                    <div className="panel panel-default">
                      <div className="panel-heading">
                        <h4 className="panel-title">{t('guest.password.change_password')}</h4>
                      </div>
                      <div className="panel-body">
                        <p>{t('guest.password.security')}</p>
                        <hr />
                        <ul>
                          <li>La contraseña debe tener al menos una mayúscula</li>
                          <li>La contraseña debe tener al menos una miniscula</li>
                          <li>La contraseña debe tener al menos un numero</li>
                          <li>La contraseña debe tener al menos un caracter especial</li>
                          <li>La contraseña debe tener al menos 8 caracteres</li>
                        </ul>
                        <div className="form-group">
                          <label className="col-sm-3 control-label" htmlFor="password">
                            {t('guest.password.label_password')}
                          </label>
                          <div className="col-sm-7">
                            <input
                              className="form-control"
                              id="password"
                              onChange={this.props.handlePasswordChange}
                              required
                              type="password"
                              value={this.props.password} />
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="col-sm-3 control-label" htmlFor="passwordConfirm">
                            {t('guest.password.label_pwdconfirm')}
                          </label>
                          <div className="col-sm-7">
                            <input
                              className="form-control"
                              id="passwordConfirm"
                              onChange={this.props.handlePasswordConfirm}
                              required
                              type="password"
                              value={this.props.passwordConfirm} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                <button type="button" className="btn btn-primary" onClick={this.props.handlePasswordSubmit}>Save changes</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(PasswordChange);


// WEBPACK FOOTER //
// ./src/dashboard/profile/PasswordChange.js